import { InputAdornment } from "@material-ui/core";
import { NeedHelp } from "../../../../need-help";
import React from "react";
import { toast } from "react-hot-toast";
import { useForgotPassword } from "../../store/forgot-password";
import { useNavigation } from "@react-navigation/native";
import { useTranslation } from "react-i18next";
import {
  AuthLayout,
  Button,
  Form,
  IconButton,
  Input,
} from "../../../../../shared/infrastructure";
import { IoArrowBack, IoPersonOutline } from "react-icons/io5";
import { animated, useSpring } from "react-spring";
import { object, string } from "yup";

export const ForgotPassword = (): React.ReactElement => {
  const { navigate } = useNavigation();
  const [t] = useTranslation("global");
  const { mutateAsync: forgotPassword, isLoading } = useForgotPassword();

  const styles = useSpring({
    from: { x: 512, opacity: 0 },
    to: { x: 0, opacity: 1 },
  });

  return (
    <AuthLayout>
      <div className="flex w-full  justify-center xl:justify-end">
        <animated.div style={styles}>
          <div className="right-0 h-[278px]  w-full max-w-[380px]  rounded-xl bg-white px-6 pb-5 pt-5 sm:w-[255px] xl:h-[345px] xl:w-[380px] xl:px-12 xl:py-5">
            <div>
              <IconButton
                size="small"
                type="button"
                onClick={() => navigate("login")}
                className="-ml-2 rounded-full bg-transparent hover:bg-gray-100 hover:text-opacity-50 xl:-ml-8"
              >
                <IoArrowBack className="text-2xl text-gray-600" />
              </IconButton>
            </div>
            <h1 className="mt-2 text-base font-medium xl:mt-6">
              {t<string>("context.public.screens.recover-account.form.title")}
            </h1>
            <p className="mt-2 text-sm text-gray-600 xl:mt-6 xl:text-tiny">
              {t<string>("context.public.screens.recover-account.form.message")}
            </p>
            <Form<{ email: string }>
              schema={object().shape({
                email: string()
                  .required(
                    t<string>(
                      "context.public.screens.recover-account.form.fields.email.validations.required"
                    )
                  )
                  .email(
                    t<string>(
                      "context.public.screens.recover-account.form.fields.email.validations.type"
                    )
                  ),
              })}
              className="mt-4 grid gap-0.5 pr-1 xl:mt-8"
              onSubmit={({ email }) => {
                void toast.promise(
                  forgotPassword({ email }),
                  {
                    loading: t<string>(
                      "context.public.screens.recover-account.form.messages.loading"
                    ),
                    success: t<string>(
                      "context.public.screens.recover-account.form.messages.success"
                    ),
                    error: t<string>(
                      "context.public.screens.recover-account.form.messages.error"
                    ),
                  },
                  {
                    className: "bg-white text-black text-sm max-w-2xl",
                  }
                );
              }}
            >
              <Input
                name="email"
                classNames={{ input: "-mb-5 h-12" }}
                variant="outlined"
                placeholder={t<string>(
                  "context.public.screens.recover-account.form.fields.email.placeholder"
                )}
                inputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IoPersonOutline className="text-base text-black" />
                    </InputAdornment>
                  ),
                }}
                rootInputProps={{
                  className: "h-6 px-1 py-1.5 text-[0.875rem]",
                }}
              />

              <div className="flex justify-end">
                <NeedHelp />
              </div>

              <Button
                className="mt-3 max-h-10 w-full text-sm xl:mt-5"
                status={isLoading ? "loading" : "default"}
              >
                <span>
                  {t<string>(
                    "context.public.screens.recover-account.form.buttons.submit"
                  )}
                </span>
              </Button>
            </Form>
          </div>
        </animated.div>
      </div>
    </AuthLayout>
  );
};
